import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
import magnifyingGlass from '@/components/svg/magnifying-glass-svg';

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#382153',
                secondary: '#382153',
                accent: '#382153',
                info: '#382153',
                success: '#2ada2b',
                error: '#f30070',
                warning: '#f30070',
            },
        },
    },

    icons: {
        values:{
            custom: {
                component: magnifyingGlass
            }
        }
    }
});
